import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json;charset=utf-8',    
    })    
};

@Injectable()
export class LunchpageService {

    constructor(private http: HttpClient) { }

    getInstructions(rootUrl:string, usercode: string, student_id:number, exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'assessor/instruction', {usercode:usercode, student_id:student_id, exam_id:exam_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    getFeedbackInfo(rootUrl: string, usercode: string, assessor_id: number, exam_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/getFeedbackA', { usercode: usercode, assessor_id: assessor_id, exam_id: exam_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
     getlanguage(rootUrl: string, usercode: string, assessor_id: number, exam_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/getLanguages', { usercode: usercode, assessor_id: assessor_id, exam_id: exam_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }     
    setFeedbackInfo(rootUrl: string, usercode: string, assessor_id: number, exam_id: number, feedback_id: number, spocname: string, mobile_numb: string, language: number, address: string, training_date: string, trainer_name: string, trainer_no: string, totloc: string, totdura: number, trainer_id: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/setFeedbackDetails', { usercode: usercode, assessor_id: assessor_id, exam_id: exam_id, feedback_id: feedback_id, actual_center_SPOC_name: spocname, actual_SPOC_mobile_no: mobile_numb, assessment_conducted_language: language, actual_center_address: address, actual_date_of_assessment: training_date, trainer_name: trainer_name, trainer_no: trainer_no, tot_location: totloc, tot_duration: totdura, trainer_id: trainer_id}, httpOptions)
            .pipe(map(user => {assessor_id
                return user;
            }));
    } 
    getFeedbackQuestions(rootUrl: string, usercode: string, assessor_id: number, exam_id: number, feedback_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/getFeedbackSingleA', { usercode: usercode, assessor_id: assessor_id, exam_id: exam_id, feedback_id: feedback_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    } 
    setFeedbackQuestions(rootUrl: string, usercode: string, assessor_id: number, exam_id: number, feedback_id: number, feedback_id_assessor: number, rating: any, file: string, attach: number, filename: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/setRatingWithIdA', { usercode: usercode, assessor_id: assessor_id, exam_id: exam_id, feedback_id: feedback_id, feedback_id_assessor: feedback_id_assessor, rating: rating, file: file, attach: attach, filename: filename }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    setFeedbackSign(rootUrl: string, usercode: string, assessor_id: number, exam_id: number, feedback_id: number, feedback_id_assessor: number, offline: number, file: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/setSignA', { usercode: usercode, assessor_id: assessor_id, exam_id: exam_id, feedback_id: feedback_id, feedback_id_assessor: feedback_id_assessor, offline: offline, file: file }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }           
}